import { render, staticRenderFns } from "./VMain.vue?vue&type=template&id=060584b6&scoped=true&"
import script from "./VMain.vue?vue&type=script&lang=js&"
export * from "./VMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060584b6",
  null
  
)

export default component.exports